<script setup lang="ts">
import { useI18n } from 'vue-i18n'

const { t } = useI18n()

const props = defineProps({
  compatibility: String,
  short: {
    type: Boolean,
    default: false,
    required: false
  }
});

</script>

<template>
<span v-if="props.compatibility==='A'" class="text-green-500" :title="t('planets.compatibility.paradise')">
  <span v-if="short" class="text-xs relative -top-0.5">&#9679;</span><span v-else>{{ t('planets.compatibility.paradise') }}</span>
</span>
<span v-else-if="props.compatibility==='B'" class="text-cyan-500" :title="t('planets.compatibility.lush')">
  <span v-if="short" class="text-xs relative -top-0.5">&#9679;</span><span v-else>{{ t('planets.compatibility.lush') }}</span>
</span>
<span v-else-if="props.compatibility==='C'" class="text-subtext" :title="t('planets.compatibility.habitable')">
  <span v-if="short" class="text-xs relative -top-0.5">&#9679;</span><span v-else>{{ t('planets.compatibility.habitable') }}</span>
</span>
<span v-else-if="props.compatibility==='D'" class="text-amber-400" :title="t('planets.compatibility.incompatible')">
  <span v-if="short" class="text-xs relative -top-0.5">&#9679;</span><span v-else>{{ t('planets.compatibility.incompatible') }}</span>
</span>
<span v-else-if="props.compatibility==='E'" class="text-red-500" :title="t('planets.compatibility.toxic')">
  <span v-if="short" class="text-xs relative -top-0.5">&#9679;</span><span v-else>{{ t('planets.compatibility.toxic') }}</span>
</span>
</template>

<style scoped lang="scss">

</style>